var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,8.25 C16.5,11.563725 13.1421,14.25 9,14.25 C8.2101,14.25 7.448775,14.15235 6.733785,13.971225 L4.342965,15.678975 C4.0947675,15.856275 3.75,15.678825 3.75,15.3738 L3.75,12.534825 C2.36148,11.4459 1.5,9.928425 1.5,8.25 C1.5,4.93629 4.8578625,2.25 9,2.25 C13.1421,2.25 16.5,4.93629 16.5,8.25 Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d91756138d65e48a7d75dc12ac3cbbdb.svg";
export { ForwardRef as ReactComponent };